// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.stage_stage_FkSZJ {
    /*
        Fixes a few extra pixels of margin/padding, that adds on to the bottom
        of the element, which messes up the chrome padding consistency
    */
    display: block;

    border-radius: 0px;
    border-top: 0.0625rem solid var(--ui-black-transparent);
    overflow: hidden;

    /* @todo: This is for overriding the value being set somewhere. Where is it being set? */
    background-color: transparent;

    /* Allow custom touch handling to prevent scrolling on Edge */
    touch-action: none;

    /* Make sure border is not included in size calculation */
    box-sizing: content-box !important;

    /* enforce overflow + reset position of absolutely-positioned children */
    position: relative;

    /* reset dark styles inherited from dark mode */
    /*
    *  不知道为什么官方不让他适配暗色模式，这可能是因为“变量”是作品的一部分？
    *  不论如何，我先加入了这个功能，具体等未来再说嘻嘻
    */
    color-scheme: light;
    color: var(--text-primary);
}

.stage_stage_FkSZJ.stage_full-screen_O7S3u {
    border: 0.0625rem solid var(--ui-black-transparent);
}

.stage_with-color-picker_reuf_ {
    cursor: none;
    z-index: 2010;
}

.stage_color-picker-background_JBgLz {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.55);
    display: block;
    z-index: 2000;
    top: 0;
    left: 0;
}

.stage_stage-wrapper_Vf6Xy {
    position: relative;
}

/* we want stage overlays to all be positioned in the same spot as the stage, but can't put them inside the border
because we want their overflow to be visible, and the bordered element must have overflow: hidden set so that the
stage doesn't "spill" out from under its rounded corners. instead, shift these over by the border width. */

.stage_stage-overlays_FKGWC {
    position: absolute;
    top: 0.0625rem;
    left: 0.0625rem;

    /* the overlay itself should not capture pointer events; only its child elements can do that */
    pointer-events: none;
}

.stage_stage-overlays_FKGWC.stage_full-screen_O7S3u {
    top: 0.0625rem;
    left: 0.0625rem;
}

.stage_monitor-wrapper_qfdUP,
.stage_frame-wrapper_lgoHn,
.stage_green-flag-overlay-wrapper_rwQtI {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
}

.stage_dragging-sprite_lNPDP {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1020;
    filter: drop-shadow(5px 5px 5px var(--ui-black-transparent-default));
}

.stage_stage-bottom-wrapper_Lexy9 {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    top: 0;
    left: 0;
    overflow: hidden;
    pointer-events: none;
}

.stage_mic-indicator_q4PN1 {
    transform-origin: bottom right;
    z-index: 45;
    pointer-events: none;
    align-self: flex-end;
}

.stage_question-wrapper_q91BI {
    z-index: 49;
    pointer-events: auto;
}

.stage_frame_v74Ux {
    background: var(--looks-transparent);
    border: 2px solid var(--looks-secondary);
    border-radius: 0.5rem;
    animation-name: stage_flash_UA_Vh;
    animation-duration: 0.75s;
    animation-fill-mode: forwards; /* Leave at 0 opacity after animation */
}

.stage_green-flag-overlay-wrapper_rwQtI {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.25);
    border-radius: 0.5rem;
    pointer-events: all;
    cursor: pointer;
}

.stage_green-flag-overlay_cWW7O {
    padding: 1rem;
    border-radius: 100%;
    background: rgba(255,255,255,0.75);
    border: 3px solid var(--ui-white-default);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 5rem;
    height: 5rem;
}

.stage_green-flag-overlay_cWW7O > img {
    width: 100%;
    object-fit: contain;
}

@keyframes stage_flash_UA_Vh {
    0% { opacity: 1; }
    100% { opacity: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/stage/stage.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI;;;KAGC;IACD,cAAc;;IAEd,kBAAkB;IAClB,uDAAuD;IACvD,gBAAgB;;IAEhB,wFAAwF;IACxF,6BAA6B;;IAE7B,6DAA6D;IAC7D,kBAAkB;;IAElB,yDAAyD;IACzD,kCAAkC;;IAElC,wEAAwE;IACxE,kBAAkB;;IAElB,+CAA+C;IAC/C;;;KAGC;IACD,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,cAAc;IACd,aAAa;IACb,MAAM;IACN,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;0GAE0G;;AAE1G;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;;IAEf,8FAA8F;IAC9F,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;;IAGI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,oEAAoE;AACxE;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,qBAAqB;IACrB,iCAAqB;IACrB,yBAAyB;IACzB,6BAA6B,EAAE,uCAAuC;AAC1E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,yCAAyC;IACzC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.stage {\n    /*\n        Fixes a few extra pixels of margin/padding, that adds on to the bottom\n        of the element, which messes up the chrome padding consistency\n    */\n    display: block;\n\n    border-radius: 0px;\n    border-top: 0.0625rem solid var(--ui-black-transparent);\n    overflow: hidden;\n\n    /* @todo: This is for overriding the value being set somewhere. Where is it being set? */\n    background-color: transparent;\n\n    /* Allow custom touch handling to prevent scrolling on Edge */\n    touch-action: none;\n\n    /* Make sure border is not included in size calculation */\n    box-sizing: content-box !important;\n\n    /* enforce overflow + reset position of absolutely-positioned children */\n    position: relative;\n\n    /* reset dark styles inherited from dark mode */\n    /*\n    *  不知道为什么官方不让他适配暗色模式，这可能是因为“变量”是作品的一部分？\n    *  不论如何，我先加入了这个功能，具体等未来再说嘻嘻\n    */\n    color-scheme: light;\n    color: var(--text-primary);\n}\n\n.stage.full-screen {\n    border: 0.0625rem solid var(--ui-black-transparent);\n}\n\n.with-color-picker {\n    cursor: none;\n    z-index: 2010;\n}\n\n.color-picker-background {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.55);\n    display: block;\n    z-index: 2000;\n    top: 0;\n    left: 0;\n}\n\n.stage-wrapper {\n    position: relative;\n}\n\n/* we want stage overlays to all be positioned in the same spot as the stage, but can't put them inside the border\nbecause we want their overflow to be visible, and the bordered element must have overflow: hidden set so that the\nstage doesn't \"spill\" out from under its rounded corners. instead, shift these over by the border width. */\n\n.stage-overlays {\n    position: absolute;\n    top: 0.0625rem;\n    left: 0.0625rem;\n\n    /* the overlay itself should not capture pointer events; only its child elements can do that */\n    pointer-events: none;\n}\n\n.stage-overlays.full-screen {\n    top: 0.0625rem;\n    left: 0.0625rem;\n}\n\n.monitor-wrapper,\n.frame-wrapper,\n.green-flag-overlay-wrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n}\n\n.dragging-sprite {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1020;\n    filter: drop-shadow(5px 5px 5px var(--ui-black-transparent-default));\n}\n\n.stage-bottom-wrapper {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.mic-indicator {\n    transform-origin: bottom right;\n    z-index: 45;\n    pointer-events: none;\n    align-self: flex-end;\n}\n\n.question-wrapper {\n    z-index: 49;\n    pointer-events: auto;\n}\n\n.frame {\n    background: var(--looks-transparent);\n    border: 2px solid var(--looks-secondary);\n    border-radius: 0.5rem;\n    animation-name: flash;\n    animation-duration: 0.75s;\n    animation-fill-mode: forwards; /* Leave at 0 opacity after animation */\n}\n\n.green-flag-overlay-wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0,0,0,0.25);\n    border-radius: 0.5rem;\n    pointer-events: all;\n    cursor: pointer;\n}\n\n.green-flag-overlay {\n    padding: 1rem;\n    border-radius: 100%;\n    background: rgba(255,255,255,0.75);\n    border: 3px solid var(--ui-white-default);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    width: 5rem;\n    height: 5rem;\n}\n\n.green-flag-overlay > img {\n    width: 100%;\n    object-fit: contain;\n}\n\n@keyframes flash {\n    0% { opacity: 1; }\n    100% { opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stage": `stage_stage_FkSZJ`,
	"full-screen": `stage_full-screen_O7S3u`,
	"fullScreen": `stage_full-screen_O7S3u`,
	"with-color-picker": `stage_with-color-picker_reuf_`,
	"withColorPicker": `stage_with-color-picker_reuf_`,
	"color-picker-background": `stage_color-picker-background_JBgLz`,
	"colorPickerBackground": `stage_color-picker-background_JBgLz`,
	"stage-wrapper": `stage_stage-wrapper_Vf6Xy`,
	"stageWrapper": `stage_stage-wrapper_Vf6Xy`,
	"stage-overlays": `stage_stage-overlays_FKGWC`,
	"stageOverlays": `stage_stage-overlays_FKGWC`,
	"monitor-wrapper": `stage_monitor-wrapper_qfdUP`,
	"monitorWrapper": `stage_monitor-wrapper_qfdUP`,
	"frame-wrapper": `stage_frame-wrapper_lgoHn`,
	"frameWrapper": `stage_frame-wrapper_lgoHn`,
	"green-flag-overlay-wrapper": `stage_green-flag-overlay-wrapper_rwQtI`,
	"greenFlagOverlayWrapper": `stage_green-flag-overlay-wrapper_rwQtI`,
	"dragging-sprite": `stage_dragging-sprite_lNPDP`,
	"draggingSprite": `stage_dragging-sprite_lNPDP`,
	"stage-bottom-wrapper": `stage_stage-bottom-wrapper_Lexy9`,
	"stageBottomWrapper": `stage_stage-bottom-wrapper_Lexy9`,
	"mic-indicator": `stage_mic-indicator_q4PN1`,
	"micIndicator": `stage_mic-indicator_q4PN1`,
	"question-wrapper": `stage_question-wrapper_q91BI`,
	"questionWrapper": `stage_question-wrapper_q91BI`,
	"frame": `stage_frame_v74Ux`,
	"flash": `stage_flash_UA_Vh`,
	"green-flag-overlay": `stage_green-flag-overlay_cWW7O`,
	"greenFlagOverlay": `stage_green-flag-overlay_cWW7O`
};
export default ___CSS_LOADER_EXPORT___;
